export default __webpack_public_path__ + "static/media/vehicles-empty-box.d82e0760.svg";